export function NoMatch() {
    return <h1>{'404 - Whoopsie'}</h1>;
}
